import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { AuthStoreService, GenericListColumn, GenericListState, SearchResult } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { PromotionGenericTransactionSearch } from 'src/app/core/model/promotion/promotion-transaction-search-generic';

import { PromotionTransaction } from '../../../core/model/promotion/promotion-transaction';
import { UserStoreService } from '../../../core/store/user-store.service';

@UntilDestroy()
@Component({
  selector: 'app-promotion-transactions-search',
  templateUrl: './promotion-transactions-search.component.html',
  styleUrls: ['./promotion-transactions-search.component.scss'],
})
export class PromotionTransactionsSearchComponent implements OnInit {
  @Input() promotionId: number;
  transactionListData: PromotionTransaction[];

  totalRecords: number;
  programDateFormat: string;

  transactionListColumnsProvider: GenericListColumn[] = [
    {
      columnNameDisplayKey: 'Date',
      sortable: true,
      fieldName: 'transactionDate',
      labelFunction: (item: PromotionTransaction) =>
        this.datePipe.transform(item.transactionDate, this.programDateFormat),
      width: '250px',
    },
    {
      columnNameDisplayKey: 'Point type',
      sortable: true,
      fieldName: 'transactionType',
    },
    {
      columnNameDisplayKey: 'Points',
      sortable: true,
      fieldName: 'totalPoints',
      labelFunction: (item: PromotionTransaction) => this.decimalPipe.transform(item.totalPoints),
      width: '150px',
    },
  ];

  transactionSearch: PromotionGenericTransactionSearch;

  formGroup: UntypedFormGroup = this.formBuilder.group({
    transactionDateBegin: [null],
    transactionDateEnd: [null],
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userStore: UserStoreService,
    private decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    private authStore: AuthStoreService
  ) {}

  ngOnInit(): void {
    this.authStore.userSettings$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((userSettings) => {
      this.programDateFormat = (userSettings!.user as any).program?.dateFormat;
    });

    this.userStore.currentPromotionTransactionResults$
      .pipe(untilDestroyed(this), filter(Boolean))
      .subscribe((searchResults: SearchResult<PromotionTransaction>) => {
        this.transactionListData = searchResults.results;
        this.totalRecords = searchResults.statistics.totalRecords;
      });

    this.resetForm();
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      this.transactionSearch = { ...this.transactionSearch, ...this.formGroup.value };
      this.searchPromotionTransactions();
    }
  }

  searchPromotionTransactions(): void {
    this.userStore.searchGenericPromotionTransactions(this.transactionSearch);
  }

  onListStateChanged(event: GenericListState): void {
    this.transactionSearch.orderBy =
      event.sortColumn && event.sortColumn !== ''
        ? {
            fields: [
              {
                sortBy: event.sortColumn,
                sortDirection: event.sortDirection as 'asc' | 'desc',
              },
            ],
          }
        : null;

    this.transactionSearch.pageSize = event.pageSize;
    this.transactionSearch.pageNumber = event.page;

    this.searchPromotionTransactions();
  }

  resetForm(): void {
    this.formGroup.reset();
    this.transactionSearch = {
      transactionDateBegin: null,
      transactionDateEnd: null,
      promotionId: this.promotionId,
      pageSize: 10,
      pageNumber: 1,
      orderBy: null,
    };

    this.searchPromotionTransactions();
  }
}
